import { render, staticRenderFns } from "./PhyThrRecApp.vue?vue&type=template&id=591ca94e&"
import script from "./PhyThrRecApp.vue?vue&type=script&lang=js&"
export * from "./PhyThrRecApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports